import type { Permission } from "@lib/permissionConstants";

export function resolvePermission(permission: Permission) {
  return permission;
}
